import React from 'react';
import ViewForm, {ViewFormField} from './ViewForm';
import i18n from 'i18next';

export default ({vin, epts, plate, make, model, year, color, odometer, score,  permissions}) => permissions ? (
  <ViewForm>
    <ViewFormField label={i18n.t('clients:VIN')} value={vin} gridColumn={4} />
    <ViewFormField label={i18n.t('clients:Vehicle passport')} value={epts} gridColumn={4} />
    <ViewFormField label={i18n.t('clients:Reg plate')} value={plate} gridColumn={4} />
    <ViewFormField label={i18n.t('clients:Make')} value={make} gridColumn={2} />
    <ViewFormField label={i18n.t('clients:Model')} value={model} gridColumn={2} />
    <ViewFormField label={i18n.t('clients:Year')} value={year} gridColumn={4} />
    <ViewFormField label={i18n.t('clients:Color')} value={color} gridColumn={4} />
    <ViewFormField label={i18n.t('clients:Mileage')} value={odometer ? `${odometer} ${i18n.t('km')}` : null} gridColumn={4} />
    <ViewFormField label={i18n.t('clients:Driving score')} value={score ? score : '0'} gridColumn={4} />
  </ViewForm>
): null;
